import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from './modal.service';
import { EditorModule } from '@tinymce/tinymce-angular';
import {ServiceModule} from '../services/service.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ResizeSearchDirective} from './resize-search.directive';
import { EdlCommonDirectiveModule, EdlCommonModalModule, EdlCommonPipesModule, EdlDatePickerModule } from '@edl-development/edl-common';
import { ErrorTailorModule } from '@ngneat/error-tailor';
import { ComponentsModule } from '../components/common-components/components.module';
import { ObservationCommentsModule } from '../components/observation-comments/observation-comments.module';
import { EdlModalDatePickerComponent } from './edl-modal-date-picker/edl-modal-date-picker.component';
import { AuthenticateModalComponent } from './authenitcate-modal/authenticate-modal.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { SignatureModalComponent } from './signature-modal/signature-modal.component';
import { EdlGenericModalComponent } from './edl-generic-modal/edl-generic-modal.component';
import { EdlSendNotificationModal } from './edl-send-notification-modal/edl-send-notification-modal.component';
import { FileAttachmentModalComponent } from './file-attachment-modal/file-attachment-modal.component';
import { LaddaModule } from 'angular2-ladda';
import { PaetepDuplicateObsModalComponent } from './paetep-duplicate-obs-modal/paetep-duplicate-obs-modal.component';
import { MultifactorSmsEnrollmentComponent } from './multifactor-sms-enrollment/multifactor-sms-enrollment.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { MultifactorTotpEnrollmentComponent } from './multifactor-totp-enrollment/multifactor-totp-enrollment.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ReauthenticationComponentModule } from '../components/reauthentication-component/reauthentication-component.module';
import { ContentEditorModalComponent } from './content-editor-modal/content-editor-modal.component';
import { RatingFormAdminConfirmModalComponent } from './rating-form-admin-confirm-modal/rating-form-admin-confirm-modal.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        EdlCommonModalModule,
        ServiceModule,
        FormsModule,
        ReactiveFormsModule,
        EdlCommonDirectiveModule,
        EdlCommonPipesModule,
        EditorModule,
        NgbModule,
        ObservationCommentsModule,
        ErrorTailorModule,
        EdlDatePickerModule,
        TimepickerModule,
        LaddaModule,
        NgxIntlTelInputModule,
        QRCodeModule,
        ReauthenticationComponentModule
    ],
    providers: [
        ModalService
    ],
    declarations: [
        ResizeSearchDirective,
        EdlModalDatePickerComponent,
        AuthenticateModalComponent,
        SignatureModalComponent,
        EdlGenericModalComponent,
        EdlSendNotificationModal,
        FileAttachmentModalComponent,
        PaetepDuplicateObsModalComponent,
        MultifactorSmsEnrollmentComponent,
        MultifactorTotpEnrollmentComponent,
        ContentEditorModalComponent,
        RatingFormAdminConfirmModalComponent
    ],
    exports: [
        ResizeSearchDirective,
        EdlModalDatePickerComponent,
        AuthenticateModalComponent,
        EdlGenericModalComponent,
        EdlSendNotificationModal
    ]
})
export class ModalModule {}
